import React from 'react';

import { instanceIdSelector } from '@lumapps/instance/ducks/selectors';
import { ContainerType } from '@lumapps/medias/types';
import { useDispatch, useSelector } from '@lumapps/redux/react';
import { uploadFile } from '@lumapps/structured-content/utils/uploadFile';

/**
 * Document upload in container
 * @return upload file to site callback
 */
export function useDocumentV2Upload() {
    const dispatch = useDispatch();
    const siteId = useSelector(instanceIdSelector);
    return React.useCallback(
        (files: File[], errorMessage?: string) => {
            return uploadFile(siteId, ContainerType.SITE, files, errorMessage)(dispatch);
        },
        [siteId, dispatch],
    );
}
